import React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import styles from './PlanHeroSection.module.scss';

const HeroSection = ({ data }) => {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getImageUrl = (imageField) => {
    if (!imageField?.fields) return '';

    const getImageUrlFromField = (field) => {
      if (!field?.value?.src) return '';
      return field.value.src;
    };

    if (isMobile) {
      return (
        getImageUrlFromField(imageField.fields.mobileImage) ||
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    if (isTablet) {
      return (
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    return getImageUrlFromField(imageField.fields.desktopImage) || '';
  };

  const imageUrl = getImageUrl(data?.image);
  const titleContent = data?.title || '';

  return (
    <div className={styles.heroSection}>
      <div className={styles.wrapper} data-aos="fade-up">
        {imageUrl && (
          <img src={imageUrl} alt="Hero background" className={styles.backgroundImage} />
        )}
        <div className={styles.contentContainer}>
          {titleContent && <div dangerouslySetInnerHTML={{ __html: titleContent }} />}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
